/* Keep the native dialog trap, close handlers and provider form submissions intact. */
(() => {
  'use strict';
  const login = document.getElementById('login-form-popup');
  if (login) {
    const syncLoginPanel = (view, moveFocus = false) => {
      const recovering = view === 'recover';
      const field = recovering ? '[data-mas-recover-email]' : '[data-mas-login-email]';
      login.dataset.masAuthView = recovering ? 'recover' : 'login';
      login.setAttribute('aria-labelledby', recovering ? 'recover-modal' : 'login-modal');
      login.setAttribute('initial-focus', field);
      if (moveFocus && login.hasAttribute('open')) {
        window.requestAnimationFrame(() => login.querySelector(field)?.focus({ preventScroll: true }));
      }
    };
    syncLoginPanel(window.location.hash === '#recover-modal' ? 'recover' : 'login');
    login.addEventListener('dialog:beforeOpen', () => syncLoginPanel(login.dataset.masAuthView));
    window.addEventListener('hashchange', () => syncLoginPanel(window.location.hash === '#recover-modal' ? 'recover' : 'login', true));
    // Theme-wide smooth-scroll handlers consume fragment links. Switch only these
    // two local panels explicitly; all other dialog links retain their handlers.
    login.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[href="#recover-modal"],a[href="#login-modal"]') : null;
      if (!link) return;
      event.preventDefault();
      event.stopPropagation();
      syncLoginPanel(link.getAttribute('href') === '#recover-modal' ? 'recover' : 'login', true);
    }, true);
  }

  // This is the existing $15 provider form, identified from its rendered markup.
  // Add readable dialog names without replacing app nodes, events, or validation.
  const formSelector = '[data-testid="klaviyo-form-Wu2qVR"]';
  let offerTrigger = null;
  let offerTimer;
  let offerOpened = false;
  const offerStatus = document.getElementById('MasWelcomeOfferStatus');
  const finishOpening = () => {
    window.clearTimeout(offerTimer);
    document.querySelectorAll('[data-mas-open-offer]').forEach((button) => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
  };
  document.querySelectorAll('[data-mas-open-offer]').forEach((button) => {
    button.addEventListener('click', () => {
      offerTrigger = button;
      offerOpened = false;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (offerStatus) offerStatus.textContent = 'Opening your welcome offer…';
      // Klaviyo's documented custom trigger opens the existing provider flow.
      // Subscription, consent, validation and code delivery remain with Klaviyo.
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'Wu2qVR']);
      offerTimer = window.setTimeout(() => {
        finishOpening();
        if (!document.querySelector(formSelector) && offerStatus) offerStatus.textContent = 'The welcome offer could not load. Please try again, or contact cs@microaquaticshop.com.au for help.';
      }, 10000);
    });
  });
  const polishOffer = () => {
    const form = document.querySelector(formSelector);
    if (!form) {
      if (offerOpened && offerTrigger) {
        offerTrigger.focus({ preventScroll: true });
        offerOpened = false;
      }
      return;
    }
    const dialog = form.closest('[role="dialog"]');
    if (!dialog) return;
    finishOpening();
    offerOpened = true;
    if (offerStatus) offerStatus.textContent = '';
    if (dialog.getAttribute('aria-label') !== 'Micro Aquatic Shop welcome offer') {
      dialog.setAttribute('aria-label', 'Micro Aquatic Shop welcome offer');
    }
    const close = dialog.querySelector('.klaviyo-close-form');
    if (close && close.getAttribute('aria-label') !== 'Close welcome offer') {
      close.setAttribute('aria-label', 'Close welcome offer');
    }
    // Keep the qualifying order value visible where the visitor enters email.
    // The provider's original offer, consent and submit controls are untouched.
    const email = form.querySelector('input[type="email"]');
    if (email && !form.querySelector('[data-mas-offer-details]')) {
      const emailRow = email.closest('[data-testid="form-row"]');
      if (emailRow) {
        const details = document.createElement('div');
        details.className = 'mas-offer-details';
        details.setAttribute('data-mas-offer-details', '');
        const title = document.createElement('strong');
        title.textContent = 'A$15 off your first order of A$100 or more';
        const text = document.createElement('p');
        text.textContent = 'Receive your code by email, then enter it at checkout.';
        details.append(title, text);
        emailRow.before(details);
      }
    }
  };
  let queued = false;
  const observer = new MutationObserver((records) => {
    if (queued || !records.some((record) => record.addedNodes.length || record.removedNodes.length)) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      polishOffer();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  polishOffer();
})();
